import { useTranslation } from "react-i18next";
import * as z from "zod";

export const useProviderRequestSchema = () => {
  const { t } = useTranslation();

  return z.object({
    jointBillServiceId: z.number({
      required_error: t(
        "providerRequestModal.form.fields.jointBillServiceId.errors.required",
      ),
    }),
    requestedServiceProviderName: z
      .object({ label: z.string(), value: z.number().optional() })
      .refine(
        (value) => !!value.label,
        t(
          "providerRequestModal.form.fields.requestedServiceProviderName.errors.required",
        ),
      ),
    customerCode: z.string().optional(),
    note: z.string().optional(),
    file: z.instanceof(File).optional(),
  });
};
